import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsRecentlyCreatedRoute: InvariantJiraRoute = {
	name: 'legacy-reports-recently-created-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'],
};
